import { EpimsBaseEntityDto } from "./epim-base.dto";
export class IncidentHumanPerformanceDto extends EpimsBaseEntityDto {
  EventTypeId: string;
  HumanPerformanceName: string;
  HumanPerformanceIconPath: string;
  SubscriptionUserId: string;  
  Version: number;
}